module.exports = __webpack_public_path__ + "static/media/LogoMaruStd-Ultra.565f9b76.svg";